import React, { useState } from "react";
import "../SignIn/SignIn.css";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import Logo from "../../../assets/communityXlogo.svg";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import forgot from "../../../assets/forgot.png";
import { MdArrowBack } from "react-icons/md";
import { ResetPasswordAPI } from "./../../API/User/ResetPassword";
import swal from "sweetalert";
import Loader from "../../Loader/Loader";
import { FaEyeSlash, FaEye } from "react-icons/fa";

const CreateNewPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [validationCheck, setValidationCheck] = useState(true);
  const [validationCheck1, setValidationCheck1] = useState(true);

  // err
  const [newPasswordErr, setNewPasswordErr] = useState("");
  const [confirmPasswordErr, setConfirmPasswordErr] = useState("");
  const [isSameErr, setIsSameErr] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [visibleOldPassword, setVisibleOldPassword] = useState(true);
  const [visibleOldPassword2, setVisibleOldPassword2] = useState(true);

  const onOldPassword = (e) => {
    let oldpswd = e.target.value;
    setOldPassword(oldpswd);
  };
  const OldPasswordVisibleHandler = () => {
    setVisibleOldPassword(true);
  };
  const OldPasswordNotVisibleHandler = () => {
    setVisibleOldPassword(false);
  };
  const OldPasswordVisibleHandler2 = () => {
    setVisibleOldPassword2(true);
  };
  const OldPasswordNotVisibleHandler2 = () => {
    setVisibleOldPassword2(false);
  };

  // onChange
  const handlePassword = (feild, value) => {
    if (feild === "newPassword") {
      setNewPassword(value);
      const passwordCond =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;
      if (passwordCond.test(value) === false) {
        setNewPasswordErr(
          "Should contain at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character!"
        );
        setValidationCheck(false);
      } else {
        setNewPasswordErr("");
        setValidationCheck(true);
      }
    }

    if (feild === "confirmPassword") {
      setConfirmPassword(value);
      setIsSameErr("");
      const passwordCond =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;
      if (passwordCond.test(value) === false) {
        setConfirmPasswordErr(
          "Should contain at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character!"
        );
        setValidationCheck1(false);
      } else {
        setConfirmPasswordErr("");
        setValidationCheck1(true);
      }
    }
  };

  const handleResetSave = async (e) => {
    e.preventDefault();
    let check = true;
    const cityId = localStorage.getItem("Otp_cityId");
    console.log(cityId, "Otp_cityId");

    if (newPassword.length == 0) {
      setNewPasswordErr("Please enter new password!");
      check = false;
    } else if (confirmPassword.length == 0) {
      setConfirmPasswordErr("Please enter confirm password!");
      check = false;
    } else if (newPassword !== confirmPassword) {
      setIsSameErr("Password did not match!");
      check = false;
    }

    if (
      validationCheck === true &&
      validationCheck1 === true &&
      check === true
    ) {
      setLoading(true);
      const payload = {
        token: localStorage.getItem("Otp_token"),
        password: confirmPassword,
        mms_city_id: parseInt(cityId),
      };
      const Response = await ResetPasswordAPI(payload, () => {
        navigate("/");
      });
      if (Response.success === true) {
        setLoading(false);
        localStorage.setItem("Otp_token", Response.token);
        swal({
          title: `${Response.p_responseMessage}`,
          icon: "success",
          buttons: "Ok",
          dangerMode: false,
        }).then((success) => {
          if (success) {
            navigate("/");
          }
        });
      } else {
        setLoading(false);
        swal({
          title: `${Response.p_responseMessage}`,
          icon: "warning",
          buttons: "Ok",
          dangerMode: false,
        }).then((success) => {
          if (success) {
            navigate("/");
          }
        });
      }
    }
  };
  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3 mobile-main">
            <Col md="6" className="page-content-left text-center hide-mobile">
              <Image src={forgot} className="my-5 py-5 imgwidth-100"></Image>
            </Col>
            <Col md="6" className="page-content-right">
              <div className="text-center mb-2 mt-5">
                <Image src={Logo} className="logo_Image"></Image>
                <p className="sign-second mt-5 pt-5 pb-2">
                  Create New password
                </p>
              </div>
              <Row>
                <div className="signemail pt-0 pb-3">
                  <Form className="formmain signin-row" autocomplete="off">
                    <Form.Group
                      className="mb-3"
                      controlId="formBasicPassword"
                      style={{ position: "relative" }}
                    >
                      <Form.Label className="form-label-custom">
                        New Password <span className="star-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type={visibleOldPassword === true ? "password" : ""}
                        placeholder="New Password"
                        className="custom-formcontrol"
                        onChange={(e) =>
                          handlePassword("newPassword", e.target.value)
                        }
                        value={newPassword}
                        autocomplete="off"
                      />
                      {visibleOldPassword === true ? (
                        <Button
                          variant="outline-secondary"
                          id="button-addon2"
                          className="edit-mainn px-2 newpswd"
                          onClick={OldPasswordNotVisibleHandler}
                        >
                          <FaEyeSlash className="eyeIcon" />
                        </Button>
                      ) : (
                        <Button
                          variant="outline-secondary"
                          id="button-addon2"
                          className="edit-mainn px-2"
                          onClick={OldPasswordVisibleHandler}
                        >
                          <FaEye className="eyeIcon" />
                        </Button>
                      )}
                      {newPasswordErr && (
                        <span className="star-required Errlabel-font_size">
                          {newPasswordErr}
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group
                      className="mb-3"
                      controlId="formBasicPassword"
                      style={{ position: "relative" }}
                    >
                      <Form.Label className="form-label-custom">
                        Confirm Password{" "}
                        <span className="star-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type={visibleOldPassword2 === true ? "password" : ""}
                        placeholder="Confirm Password"
                        className="custom-formcontrol"
                        onChange={(e) =>
                          handlePassword("confirmPassword", e.target.value)
                        }
                        value={confirmPassword}
                        autocomplete="off"
                      />
                      {visibleOldPassword2 === true ? (
                        <Button
                          variant="outline-secondary"
                          id="button-addon2"
                          className="edit-mainn px-2 confirmpswd"
                          onClick={OldPasswordNotVisibleHandler2}
                        >
                          <FaEyeSlash className="eyeIcon" />
                        </Button>
                      ) : (
                        <Button
                          variant="outline-secondary"
                          id="button-addon2"
                          className="edit-mainn px-2"
                          onClick={OldPasswordVisibleHandler2}
                        >
                          <FaEye className="eyeIcon" />
                        </Button>
                      )}
                      {confirmPasswordErr && (
                        <span className="star-required Errlabel-font_size">
                          {confirmPasswordErr}
                        </span>
                      )}
                    </Form.Group>
                    {isSameErr && (
                      <span className="star-required Errlabel-font_size">
                        {isSameErr}
                      </span>
                    )}

                    <div className="text-center">
                      <Button
                        variant="primary"
                        type="submit"
                        className="green-btn mt-3"
                        onClick={(e) => handleResetSave(e)}
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                </div>
                <Link to="/">
                  <p className="text-center back-btn">
                    <MdArrowBack />
                    Back
                  </p>
                </Link>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CreateNewPassword;
